import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=536a6f6e&"
import script from "./Impact.vue?vue&type=script&lang=js&"
export * from "./Impact.vue?vue&type=script&lang=js&"
import style0 from "./Impact.vue?vue&type=style&index=0&id=536a6f6e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports